//Styles
import './nav.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt } from '@fortawesome/pro-duotone-svg-icons';
import Logo from 'assets/logo.png';




export interface NavProps {
    public?: boolean;
}


const Nav = (props: NavProps) => {
    return (
        <div className="public-nav">

            <div className="nav-content">
                <div className="logo">
                    <img src={Logo} alt="NGP Flexer" />
                </div>
                
                <div className="contact">
                    <FontAwesomeIcon icon={faPhoneAlt} className="icon" />
                    <a href="tel:+44 (0)330 0300 800">Need Help? <br />+44 (0)330 0300 800</a>
                </div>
            </div>

        </div>
    )
}



export default Nav;